import React from 'react';

const Solutions = () => {
  return (
    <div>
      <h3>this is where the solutions go</h3>
    </div>
  );
};

export default Solutions;
